import { Box, Carousel, Image } from "grommet";
import { PropsWithChildren } from "react";
import knob1 from "../images/IMG_2698.jpg";
import knob2 from "../images/IMG_2704.jpg";
import knob3 from "../images/IMG_2707.jpg";
import knob4 from "../images/IMG_2713.jpg";
import knob5 from "../images/IMG_2716.jpg";
import knob6 from "../images/IMG_2721.jpg";
import knob7 from "../images/IMG_2722.jpg";
import knob8 from "../images/IMG_2727.jpg";
import knob9 from "../images/IMG_2729.jpg";
import knob10 from "../images/IMG_2738.jpg";
import knob11 from "../images/IMG_2740.jpg";
import knob12 from "../images/IMG_2741.jpg";
import knob13 from "../images/IMG_2745.jpg";

export const KnobGallery: React.FC<PropsWithChildren> = () => {
  return (
    <Box pad="medium">
      <div className="image-container">
        <Carousel fill controls="arrows" style={{ aspectRatio: "1.55" }}>
          <Image fit="cover" src={knob1} />
          <Image fit="cover" src={knob2} />
          <Image fit="cover" src={knob3} />
          <Image fit="cover" src={knob4} />
          <Image fit="cover" src={knob5} />
          <Image fit="cover" src={knob6} />
          <Image fit="cover" src={knob7} />
          <Image fit="cover" src={knob8} />
          <Image fit="cover" src={knob9} />
          <Image fit="cover" src={knob10} />
          <Image fit="cover" src={knob11} />
          <Image fit="cover" src={knob12} />
          <Image fit="cover" src={knob13} />
        </Carousel>
      </div>
    </Box>);

};